export default __webpack_public_path__ + "static/media/1457.39b694ec.png";